import request from './axios'
// 
export const schoolOrUserSchool = (params) => {
	return request({
		url: '/schoolOrUserManagement/school',
		method: "post",
		data: params,
	})
}
// 学生-新增
export const addStudent = (params) => {
	return request({
		url: '/schoolOrUserManagement/addStudent',
		method: "post",
		data: params,
	})
}
// 学生信息-导入
export const importStudentInfo = (params, schoolId, userId) => {
	return request({
		url: `/schoolOrUserManagement/importStudentInfo?schoolId=${schoolId}&userId=${userId}`,
		method: "post",
		data: params,
		responseType: 'blob'

	})
}
// 学生信息-nfc
export const importNfc = (params) => {
	return request({
		url: `/schoolOrUserManagement/importNfc`,
		method: "post",
		data: params,
	})
}
//学生信息删除
export const schoolOrUserinfoDelete = (params) => {
	return request({
		url: `/schoolOrUserManagement/deleteStudentInfo`,
		method: "delete",
		params
	})
}

// 学生信息-导出
export const exportStudentInfo = (schoolld, gradeld, classId) => {
	return request({
		url: `/schoolOrUserManagement/exportStudentInfo?schoolId=${schoolld}&gradeld=${gradeld}&classId=${classId}`,
		method: "get",
		responseType: 'blob'
	})
}

// 教师信息-导出
export const exportTeacherInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/exportTeacherInfo`,
		method: "post",
		data: params,
		responseType: 'blob'
	})
}

// 通过组织ID获取对应职位和老师
export const getTeacherSubject = (orgId) => {
	return request({
		url: `/schoolOrUserManagement/getTeacherSubject?orgId=${orgId}`,
		method: "get",
	})
}


// 通过学校ID获取对应学校老师
export const getTeacherList = (params) => {
	return request({
		url: `/schoolOrUserManagement/getTeacherList`,
		method: "get",
		params: params,
	})
}

// 学生信息-查询
export const findStudentInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/findStudentInfo`,
		method: "get",
		params: params,
	})
}
// 学生信息-修改
export const updateStudentInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/updateStudentInfo`,
		method: "post",
		data: params,
	})
}
// 学生信息
export const deleteStudentInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/deleteStudentInfo`,
		method: "post",
		data: params,
	})
}
// 学校
export const school = (params) => {
	return request({
		url: `/schoolOrUserManagement/school`,
		method: "post",
		data: params,
	})
}

// 学校
export const schoolList = (userId) => {
	return request({
		url: `/schoolOrUserManagement/schoolList?userId=${userId}`,
		method: "get"
	})
}
//获取教师下面的年级班级 
export const  GettecherIdlistNew= (userId,schoolId) => {
	return request({
		url: `/schoolOrUserManagement/getGradeAndClassByUserId?userId=${userId}&&schoolId=${schoolId}`,
		method: "get"
	})
}

// 年级列表老的速度慢的
export const getGradeList = (params, id) => {
	return request({
		url: `/schoolOrUserManagement/gradeList?schoolId=${id}`,
		method: "post",
		data: params,
	})
}

// 班级列表老的速度慢的
export const getFindClassList = (params, id) => {
	return request({
		url: `/schoolOrUserManagement/findClassList?gradeId=${id}`,
		method: "post",
		data: params,
	})
}


// 年级列表 速度快的 新的
export const gradeList = (params, id) => {
	return request({
		url: `/app/getGradeList?schoolId=${id}`,
		method:"get",
	})
}
// 班级列表 速度快的 新的
export const findClassList = (params, id) => {
	return request({
		url: `/app/getClassList?gradeId=${id}`,
		method:"get",
	})
}


//   年级详情
export const schoolOrUserGradeInfo = (gradeId) => {
	return request({
		url: `/schoolOrUserManagement/findeGradeInfo?gradeId=${gradeId}`,
		method: "get",
	})
}
// 年级-新增
export const addGrade = (params) => {
	return request({
		url: `/schoolOrUserManagement/addGrade`,
		method: "post",
		data: params,
	})
}
//年级-修改
export const updateaddGrade = (params) => {
	return request({
		url: `/schoolOrUserManagement/updateGradeInfo`,
		method: "post",
		data: params,
	})
}
//年级删除
export const teaddGradeDlete = (gradeId) => {
	return request({
		url: `/schoolOrUserManagement/deleteGradeInfo?gradeId=${gradeId}`,
		method: "delete",
	})
}
// 老师-新增
export const addTeacherInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/addTeacherInfo`,
		method: "post",
		data: params,
	})
}
// 班级-新增
export const addClass = (params) => {
	return request({
		url: `/schoolOrUserManagement/addClass`,
		method: "post",
		data: params,
	})
}
// 学校详细信息-查询
export const findSchoolInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/findSchoolInfo`,
		method: "get",
		params: params,
	})
}
// 老师详细信息-查询
export const findTeacherInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/findTeacherInfo`,
		method: "get",
		params: params,
	})
}
// 老师信息-修改
export const updateTeacherInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/updateTeacherInfo`,
		method: "post",
		data: params,
	})
}
// 班级详细信息-查询
export const findClassInfo = (classId) => {
	return request({
		url: `/schoolOrUserManagement/findClassInfo?classId=${classId}`,
		method: "get",
	})
}
//班级修改
export const schoolClassupdate = (params) => {
	return request({
		url: `/schoolOrUserManagement/updateClassInfo`,
		method: "post",
		data: params
	})
}
//     班级删除
export const schooldeleteClass = (classId) => {
	return request({
		url: `/schoolOrUserManagement/deleteClassInfo?classId=${classId}`,
		method: "delete",
	})
}

//课堂测试
export const classroomAnswerList = (params) => {
	return request({
		url: `/classroomAnswer/list`,
		method: "post",
		data: params,
	})
}
//课堂测试删除
export const classroomDelete = (params) => {
	return request({
		url: `/classroomAnswer/exam/delete`,
		method: "delete",
		params,
	})
}
// 课堂测试结果
export const roomLookList = (params, examId) => {
	return request({
		url: `/classroomAnswer/examResultList?examId=${examId}`,
		method: "post",
		data: params
	})
}

//修改考试状态
export const classroomAnswerStatus = (id, status) => {
	return request({
		url: `/classroomAnswer/exam/updateStatus?id=${id}&&status=${status}`,
		method: "get",
	})
}
//    发布检验查询用户权限
export const FindSchoolexamResult = (userId) => {
	return request({
		url: `/classroomAnswer/examResult/findSchool?userId=${userId}`,
		method: "get",
	})
}
//发布测试
export const classRoomPublishTest = (params) => {
	return request({
		url: `/classroomAnswer/publishTest`,
		method: "post",
		data: params,
	})
}
//课堂测试-录入-查询
export const examBaseInfo = (params) => {
	return request({
		url: `/classroomAnswer/exam/baseInfo`,
		method: "get",
		params: params,
	})
}
//课堂测试-录入-提交
export const examAddAnswer = (params) => {
	return request({
		url: `/classroomAnswer/exam/addAnswer`,
		method: "post",
		data: params,
	})
}

//学校考勤短信查询
export const schoolQuery = (params) => {
	return request({
		url: `/schoolOrUserManagement/schoolAttendanceMsgFind`,
		method: "get",
		params
	})
}
//学生绑定查询
export const StudentBindInfo = (imei) => {
	return request({
		url: `/schoolOrUserManagement/studentBindingInfo?imei=${imei}`,
		method: "post",
	})
}
//学生筛选导出
export const studentDaoChuInfo = (params) => {
	return request({
		url: `/schoolOrUserManagement/filterExportStudentInfo`,
		method: "post",
		data: params,
		responseType: 'blob'

	})
}

export const getFaceStudentCount = (params) => {
	return request({
		url: `/Subscribe/getFaceStudentCount`,
		method: "post",
		data: params,
	})
}

export const getFaceTeacherCount = (params) => {
	return request({
		url: `/Subscribe/getFaceTeacherCount`,
		method: "post",
		data: params,
	})
}

export const uploadFace = (params) => {
	return request({
		url: `/Subscribe/uploadFace`,
		method: "post",
		data: params,
	})
}


export const zipFileUpload = (params, onUploadProgress) => {
	return request({
		url: `/Subscribe/zipFileUpload`,
		method: "post",
		data: params,
		onUploadProgress: progressEvent => {
			// 计算上传进度
			const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
			onUploadProgress(percentCompleted);
		}
	})
}


//通行策略分页查询
export const strategyPage = (params) => {
	return request({
		url: `/Subscribe/strategyPage`,
		method: "post",
		data: params,
	})
}


//添加或修改通行策略
export const insertOrUpdateFaceStrategy = (params) => {
	return request({
		url: `/Subscribe/insertOrUpdateFaceStrategy`,
		method: "post",
		data: params,
	})
}

//添加或修改通行策略
export const deleteFaceStrategy = (id) => {
	return request({
		url: `/Subscribe/deleteFaceStrategy?id=${id}`,
		method: "get"
	})
}

//下发通行策略
export const issuedStrategy = (id,data) => {
	return request({
		url: `Subscribe/issuedStrategy?loginId=${id}&strategyIds=`+ JSON.stringify(data),
		method: "get"
	})
}

//获取通行策略列表
export const strategyList = (id) => {
	return request({
		url: `/Subscribe/strategyList?loginId=${id}`,
		method: "get",
	})
}

// 请假数据导出
export const exportLeaveData = (params) => {
	return request({
		url: `/schoolOrUserManagement/exportLeaveData`,
		method: "post",
		responseType: 'blob',
		data: params,
	})
}



